import { render, staticRenderFns } from "./MainTopNav.vue?vue&type=template&id=3d8c38ae&"
import script from "./MainTopNav.vue?vue&type=script&lang=js&"
export * from "./MainTopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports